import { cn, ColorOrCustom, dynamicStyling } from 'styles';

interface DotProps {
  children?: never;
  className?: string;
  size?: number;
  color: ColorOrCustom;
  circle?: boolean;
}

/**
 * UI element
 *
 * Easily render a colored dot/box to indicate activity, etc
 */
export function Dot({ className, size = 12, color, circle = true }: DotProps) {
  return (
    <span
      {...dynamicStyling({
        size,

        bg: color,

        className: cn(
          'inline-block flex-shrink-0',
          circle ? 'rounded-full' : 'rounded-lg',
          className,
        ),
      })}
    />
  );
}
